import { defineStore } from 'pinia'

export const useProductListFilterStore = defineStore('productListFilter', {
    state: () => ({
        openFilterTitle: null as string | null,
        showMoreFilters: false,
        scrollPosition: 0,
    }),
    actions: {
        saveScrollPosition(position: number) {
            this.scrollPosition = position
        },
        restoreScrollPosition() {
            return this.scrollPosition
        },
        clearScrollPosition() {
            this.scrollPosition = 0
        },
    },
})
